import React from 'react';
import logo from './../../images/logo.png';

export const ErrorFallback = () => {
  return (
    <div className="flex h-full flex-col items-center justify-center p-[15px]">
      <img src={logo} alt="Logo" className="logo mb-2.5 max-w-[200px]" />

      <h1 className="mb-2.5 max-w-[650px] text-center text-2xl tracking-normal">
        Oops, this should not have happened...
      </h1>
      <p className="mb-[30px] max-w-[450px] text-center text-lg">
        We have been notified about this issue and will look into it as soon as possible!
      </p>

      <button className="rs-button text-white" onClick={() => window.location.reload()}>
        Click here to reload this page
      </button>
    </div>
  );
};
